"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafeBroadcastChannel = void 0;
const broadcast_channel_1 = require("broadcast-channel");
let SafeBroadcastChannel = (_a = globalThis.window) === null || _a === void 0 ? void 0 : _a.BroadcastChannel;
exports.SafeBroadcastChannel = SafeBroadcastChannel;
if (SafeBroadcastChannel === undefined) {
    exports.SafeBroadcastChannel = SafeBroadcastChannel = (_b = globalThis.self) === null || _b === void 0 ? void 0 : _b.BroadcastChannel;
}
class BroadcastChannelPolyfill {
    //removeEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | EventListenerOptions): void;
    constructor(name) {
        this.name = name;
        this.closed = false;
        const createChannel = () => {
            this.channel = new broadcast_channel_1.BroadcastChannel(name, {
                idb: {
                    onclose: () => {
                        var _a;
                        // the onclose event is just the IndexedDB closing.
                        // you should also close the channel before creating
                        // a new one.
                        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.close();
                        createChannel();
                    }
                }
            });
        };
        createChannel();
        if (this.channel !== undefined) {
            this.channel.onmessage = (msg) => {
                if (this.onmessage !== null) {
                    this.onmessage(msg);
                }
            };
        }
        this.onmessage = null;
        this.onmessageerror = null;
    }
    /**
     * Closes the BroadcastChannel object, opening it up to garbage collection.
     */
    close() {
        var _a;
        this.closed = true;
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.close();
    }
    /**
     * Sends the given message to other BroadcastChannel objects set up for this channel. Messages can be structured objects, e.g. nested objects and arrays.
     */
    postMessage(message) {
        var _a;
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.postMessage({ data: message });
    }
    addEventListener(_type, _listener, _options) {
        throw new Error('BroadcastChannel.addEventListener is not supported in this platform');
    }
    removeEventListener(_type, _listener, _options) {
        throw new Error('BroadcastChannel.addEventListener is not supported in this platform');
    }
}
if (SafeBroadcastChannel === undefined) {
    exports.SafeBroadcastChannel = SafeBroadcastChannel = BroadcastChannelPolyfill;
}
//# sourceMappingURL=broadcastchannel.js.map